export const ARTICLE_SUCCESS = "articles/ARTICLE_SUCCESS";
export const ARTICLES_REQUEST = "articles/ARTICLES_REQUEST";
export const ARTICLES_FAILURE = "articles/ARTICLES_FAILURE";
export const ARTICLES_SUCCESS = "articles/ARTICLES_SUCCESS";
